import Player from '@vimeo/player'

/* const mainVideo = () => {  
    let videos = document.querySelectorAll('[data-video]');
    videos.forEach(video => {
        let videoID = video.getAttribute('data-video');
        let domelement = video.querySelector('.hero-slider__video-item');
        let domID = domelement.getAttribute('id');
        let play = video.querySelector('[data-videoplay]');
        let layer = video.querySelector('[data-videolayer]');
        var options = {
            id: videoID,
            controls: 0,
            title: false,
        };
        var videoPlayer = new Player(domID, options);
        videoPlayer.setVolume(0);
        layer.addEventListener('click', () =>{
            if(play.classList.contains('d-none')){
                videoPlayer.pause();
                play.classList.remove('d-none');
            }else{
                videoPlayer.play();
                play.classList.add('d-none');
            }
        }); 
    });
    
} */

const backgroundVideo = () => {  
    let video = document.querySelector('[data-video-bg]');
    let videoID = video.getAttribute('data-video-bg');
    var options = {
        id: videoID,
        controls: 0,
        title: false,
        background: true,
    };
    var videoPlayer = new Player('vimeo-video-bg', options);
    videoPlayer.on('loaded', function() {
        videoPlayer.setVolume(0);
        videoPlayer.play();
        resizeVideo();
        window.addEventListener('resize', resizeVideo);
    });
}

function resizeVideo() {
    const videoAspectRatio = 16 / 9; // Sostituisci con il rapporto del tuo video
    let newWidth = window.innerWidth;
    let newHeight = window.innerHeight;
    let newVideoHeight = newWidth / videoAspectRatio;

    if (newVideoHeight < newHeight) {
        newWidth = newHeight * videoAspectRatio;
        newVideoHeight = newHeight; // Ora è l'altezza piena
    }

    const iframe = document.querySelector('#vimeo-video-bg iframe');
    iframe.style.width = `${newWidth}px`;
    iframe.style.height = `${newVideoHeight}px`;
}

const vimeoplayers = () => {
    /* let video = document.querySelector('[data-video]');
    if(video){
        mainVideo();
    } */
    let video_bg = document.querySelector('[data-video-bg]');
    if(video_bg){
        backgroundVideo();
    }
}

export default vimeoplayers;